import { render, staticRenderFns } from "./ResultBasicInfo.vue?vue&type=template&id=4d6a41db&scoped=true&"
import script from "./ResultBasicInfo.vue?vue&type=script&lang=js&"
export * from "./ResultBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResultBasicInfo.vue?vue&type=style&index=0&id=4d6a41db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a41db",
  null
  
)

export default component.exports